import { ColumnDefinition } from '../../../sharedComponents/table/SortedTableHeader';

export enum ServiceOrdersTableColumns {
    HIGHLIGHT = 'highlight',
    EXTERNAL_ID = 'externalId',
    STATUS = 'status',
    VIN = 'vin',
    LOCATION_ID = 'locationId',
    LOCATION_CITY = 'locationCity',
    MANUFACTURER = 'manufacturer',
    MODEL = 'model',
    EXECUTION_DATE_START = 'executionDateStart',
    EXECUTION_DATE_END = 'executionDateEnd',
    SERVICE_CODE = 'serviceCode',
    SERVICE_NAME = 'serviceName',
    SERVICE_DESCRIPTION = 'serviceDescription',
    ACTION_BUTTON = 'actionButton',
    ORDER_ISSUE_DATE = 'orderIssueDate',
    EXTERNAL_OPTION_ID = 'externalOptionId',
}

export const serviceOrderColumnDefinition: ColumnDefinition<ServiceOrdersTableColumns>[] = [
    { column: ServiceOrdersTableColumns.HIGHLIGHT, labelId: undefined, sortable: false, fixedWith: 40 },
    {
        column: ServiceOrdersTableColumns.EXTERNAL_ID,
        labelId: 'outboundPortal.serviceOrders.table.identifier',
        sortable: false,
        alwaysVisible: true,
    },
    { column: ServiceOrdersTableColumns.STATUS, labelId: 'outboundOrderBook.common.heading.status', sortable: true },
    {
        column: ServiceOrdersTableColumns.VIN,
        labelId: 'outboundOrderBook.common.heading.vin',
        sortable: false,
        alwaysVisible: true,
    },
    {
        column: ServiceOrdersTableColumns.LOCATION_ID,
        labelId: 'outboundOrderBook.serviceOrder.table.heading.locationId',
        sortable: true,
    },
    {
        column: ServiceOrdersTableColumns.LOCATION_CITY,
        labelId: 'outboundOrderBook.serviceOrder.table.heading.location',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.MANUFACTURER,
        labelId: 'outboundOrderBook.common.heading.manufacturer',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.MODEL,
        labelId: 'outboundOrderBook.common.heading.model',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.ORDER_ISSUE_DATE,
        labelId: 'outboundOrderBook.common.heading.orderIssuedAt',
        sortable: true,
    },
    {
        column: ServiceOrdersTableColumns.EXECUTION_DATE_START,
        labelId: 'outboundPortal.serviceOrder.table.executionStartDate',
        sortable: true,
    },
    {
        column: ServiceOrdersTableColumns.EXECUTION_DATE_END,
        labelId: 'outboundPortal.serviceOrders.table.executionEndDate',
        sortable: true,
    },
    {
        column: ServiceOrdersTableColumns.SERVICE_CODE,
        labelId: 'outboundPortal.serviceOrders.table.serviceCode',
        sortable: true,
    },
    {
        column: ServiceOrdersTableColumns.SERVICE_NAME,
        labelId: 'outboundPortal.serviceOrders.table.serviceName',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.SERVICE_DESCRIPTION,
        labelId: 'outboundPortal.serviceOrders.table.serviceDescription',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.EXTERNAL_OPTION_ID,
        labelId: 'outboundPortal.serviceOrders.table.externalOptionId',
        sortable: false,
    },
    {
        column: ServiceOrdersTableColumns.ACTION_BUTTON,
        labelId: 'outboundPortal.serviceOrders.table.action',
        sortable: false,
    },
];
